// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-icon-delete[data-v-abcca512]{position:absolute;top:15px;left:60px;cursor:pointer;color:#f56c6c}.icon-item[data-v-abcca512]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.icon-item[data-v-abcca512]:hover{color:#1976d3;background:#f5f7fa}", ""]);
// Exports
module.exports = exports;
